import { storeToRefs } from "pinia"
import { useAuthStore } from "~/store/auth"
import { hasPermission } from "#shared/utils/permissions"

const PUBLIC_ROUTES = ['auth-signin', 'auth-password', 'auth-forgot']

export default defineNuxtRouteMiddleware(async (to) => {
    const store = useAuthStore()
    const { god } = storeToRefs(store)

    // O cookie é httpOnly (invisível ao JS) — quem diz se há sessão é o GET /api/god/me
    if (!god.value) {
        await store.fetchMe()
    }

    const isPublic = PUBLIC_ROUTES.includes(String(to?.name))

    if (god.value && isPublic) {
        return navigateTo('/')
    }

    if (!god.value && !isPublic) {
        return navigateTo('/auth/signin')
    }

    // Gating por página: definePageMeta({ permissions: [...] }) — sem meta, basta estar logado
    const required = to?.meta?.permissions as string[] | undefined
    if (god.value && required?.length && !hasPermission(god.value.permissions, required)) {
        return navigateTo('/')
    }
})
